import ProxyBase from '../../../../../../core/proxies/ProxyBase'

export class BusinessSizeProxy extends ProxyBase {
  getBusinessSizeTable(params) {
    return this.get('CompanySize', params)
  }
  exportBusinessSize(params) {
    return this.post('CompanySize/Export', params, {}, 'download')
  }
}

export default new BusinessSizeProxy('IndustryOverview/')
